<template>
  <div class="supplementary" :style="{ backgroundImage: `url(${orgBackground})`}">
    <div class="center">
      <div class="top">
        <div class="iconBoxs" @click="temporary('order')">
          <img :src="orderBtn" alt="">
          <span>我的订单</span>
        </div>
      </div>
      <div class="main">
        <div class="information">
          <div class="inforTop">
            <img :src="zsbH5MotorStartIcon" alt="">
            <span class="title">影像资料</span>
            <span class="titleSmall">上传影像可提高自核通过率</span>
          </div>
          <div class="mainBox">
            <div
              v-for="(item, index) in tabsContent"
              :key="index"
              class="each-tab"
              :class="{ active: item.active }"
              @click="showMore(item, index)"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div
          v-for="(item, key) in tabsContent"
          v-show="item.state"
          :key="key"
          class="imgBox"
        >
          <div class="imgIconBox">
            <span class="title" style="display:block;margin-bottom:.05rem;">
              {{ item.text }}
            </span>
            <span class="imgIconCon" @click="showMore(item, key)"><img :src="zsbH5MotorCancel" alt=""></span>
          </div>
          <div class="img-choose">
            <div
              v-for="(item, index) in tabsContent[key].src"
              :key="index"
              class="img-content"
            >
              <img
                class="delete-img"
                :src="deleteImg"
                alt=""
                @click="IMGRemove(item, key, index)"
              >
              <TokenImage :imageUrl='imgUrl + item.path' :className="'downLoad-img'" :token='userToken' class="downLoad-img"/>
              <!-- <TokenImage v-if="isImgToken" :imageUrl='imgUrl + item.path' imageType="view" className="downLoad-img"></TokenImage>
              <img v-else class="downLoad-img" :src="imgUrl + item.path" alt="" /> -->
            </div>
            <div
              v-if="tipVisible"
              class="img-content"
              @change="handleFile($event, key)"
            >
              <input ref="fileBtn" type="file" multiple accept="image/*">
              <img class="downLoad-img" :src="imgUrlIcon" alt="">
            </div>
          </div>
        </div>
        <div class="agreed">
          <div class="agreedTop">
            <div class="left">
              <img :src="zsbH5MotorAgreeIcon" alt="">
              <span class="title">特别约定</span>
            </div>
            <img :src="zsbH5MotorAddIcon" alt="" @click="goSpecial">
          </div>
          <div class="agreedMain">
            <div class="title titles">
              交强险特约
            </div>
            <div v-for="(item,index) in arrClause" :key="index">
              <div class="agreedMainTop">
                <span>{{ item.clauseName }}</span>
                <img v-if="item.proType!=='2'" :src="zsbH5MotorDelIcon" alt="" @click="delAgreed(item,index)">
              </div>
              <p>{{ item.clauses }}</p>
            </div>
          </div>
        </div>
        <div class="descr">
          <div class="inforTop">
            <img :src="zsbH5MotorDesIcon" alt="">
            <span class="title">备注说明</span>
          </div>
          <textarea
            v-model="remark"
            class="input-style"
            type="text"
            maxlength="500"
            placeholder="请输入备注信息，信息将在核保时展示"
          />
          <div class="textMaxLength">
            {{ maxNum }}/500
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="btn btnTop" style="margin-right:.1rem" @click="temporary">
        暂存
      </div>
      <div class="btn" @click="submitBtn">
        提交核保
      </div>
    </div>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant'
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
import TokenImage from '@/components/tokenImage'
import { removeWatermark, setWaterMark } from '../../watermark'
export default {
  components: {
    Loading: Loading,
    TokenImage
  },
  data() {
    return {
      orgBackground: '',
      devUrl: api.devUrl,
      imgUrl: api.imgIdUrl,
      tabsContent: [],
      imgUrlIcon: api.imgAllUrl + '/sales400709.png',
      deleteImg: api.imgAllUrl + '/sales240709.png',
      tipVisible: false,
      fileIdList: [],
      remark: '', // 备注说明
      maxNum: 0, // 备注说明长度
      arrClause: [], // 特约返回数据
      switchs: false,
      engageList: [],
      zsbH5MotorStartIcon: api.imgAllUrlZSB + '/zsbH5MotorStartIcon.png',
      zsbH5MotorCancel: api.imgAllUrlZSB + '/zsbH5MotorCancel.png',
      zsbH5MotorAgreeIcon: api.imgAllUrlZSB + '/zsbH5MotorAgreeIcon.png',
      zsbH5MotorAddIcon: api.imgAllUrlZSB + '/zsbH5MotorAddIcon.png',
      zsbH5MotorDelIcon: api.imgAllUrlZSB + '/zsbH5MotorDelIcon.png',
      zsbH5MotorDesIcon: api.imgAllUrlZSB + '/zsbH5MotorDesIcon.png',
      sumbData: '',
      cInfo: '',
      orderBtn: api.imgAllUrlZSB + '/order-btn.png',
      itemFileDataList: [],
      resultObj: {} // 回显数据
    }
  },
  watch: {
    remark: function(newVal, oldVal) {
      this.maxNum = newVal.length
    }
  },
  created() {
    this.userToken = localStorage.getItem('setToken') || checkFormat.getUrlKey('token')
  },
  mounted() {
    this.tipVisible = true
    // console.log(this.$route.params,'setEngageList');
    console.log(localStorage.getItem('setMotorAreaName'), ']]]]')
  },
  activated() {
    if (this.$store.state.motorOrderDetail && Object.keys(this.$store.state.motorOrderDetail).length > 0) {
      this.getMortorQuery()
    } else {
      // 获取影像资料排序
      this.getContentTabs()
    }
    this.$store.commit('set_motorStep', '4')
    this.$store.commit('set_showStep', true)
    this.arrClause = this.$store.state.engageList
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(3, this.cInfo.identifyNum)
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
    }
  },
  deactivated() {
    Toast.clear()
    this.$store.commit('setStep', '')
    removeWatermark()
  },
  beforeDestroy() {
    this.traceBack()
  },
  methods: {
    temporary(type) { // 暂存
      const imageInfoLists = []
      this.fileIdList.forEach(value => {
        const objs = {
          fileId: value.fileId,
          fileType: value.fileType
        }
        imageInfoLists.push(objs)
      })
      const JQfile = {
        businessNo: null,
        riskCode: '0591'

      }
      const data = {
        orderId: this.$store.state.motorOrderId,
        terminalId: 'H5',
        orderOrigin: 'DP_OWXPA',
        channelCode: 'DP_OWXPA',
        productCode: 'motor_product',
        productName: '摩托车险',
        itemFileDataList: [],
        engageList: this.arrClause ? this.arrClause : [],
        carOwnerInfo: this.$store.state.carOwnerInfo, // 车主信息
        vehicleInfo: this.$store.state.motorBaseInfo, // 车辆信息
        insuredList: this.$store.state.insuredList,
        taxRelifInfo: this.$store.state.motorTaxRelifInfo,
        submitInfo: {
          remark: this.remark
        }
      }
      if (type === 'order') {
        this.$router.push('/motor/orderList')
      }
      if (imageInfoLists.length !== 0) {
        JQfile.fileList = imageInfoLists
        data.itemFileDataList.push(JQfile)
      }
      this.switchs = true
      this.$http
        .post(api.motorSava, data)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            this.$store.commit(
              'setItemFileDataList',
              res.data.resultObj.itemFileDataList
            )
            this.$store.commit('setEngageList', res.data.resultObj.engageList)
          } else {
            this.$toast(res.data.rtnMsg)
          }
        })
        .catch(error => {
          console.log(error)
          this.switchs = false
        })
    },
    submitBtn() { // 提交核保
      const param = {
        agentCode: '',
        orderOrigin: 'DP_OWXPA',
        channelCode: 'DP_OWXPA',
        productCode: 'motor_product',
        productName: '摩托车险',
        orderId: this.$store.state.motorOrderId,
        ordersAmount: this.$store.state.motorTaxRelifInfo.sumPremium,
        engageList: this.arrClause ? this.arrClause : [],
        baseInfo: this.$store.state.motormotorBaseInfo,
        vehicleInfo: this.$store.state.motorBaseInfo,
        carOwnerInfo: this.$store.state.carOwnerInfo, // 车主信息
        insuredList: this.$store.state.insuredList,
        submitInfo: {
          remark: this.remark
        }
      }
      this.switchs = true
      this.$http.post(api.underwritingForMotor, param)
        .then(res => {
          this.switchs = false
          console.log(this.$store.state.motorTraceBack, 'this.$store.state.motorTraceBack')
          if (res.data.rtnCode === '0000') {
            this.sumbData = res.data
            // 可回溯修改 20200908 begin 因为只有提交核保成功，才能返回订单号保单号等信息，因此只有提交核保成功才调这个接口
            try {
              this.traceBack(res.data).finally(() => {
                this.$router.push({
                  name: 'motorConfirm',
                  query: {
                    orderId: this.$store.state.motorOrderId,
                    orderNo: res.data.orderNo,
                    encryptKey: res.data.encryptKey,
                    terminalId: 'H5',
                    channelCode: 'HeNanMotorBike',
                    isH5: '1'
                  }
                })
              })
            } catch (e) {
              this.$router.push({
                name: 'motorConfirm',
                query: {
                  orderId: this.$store.state.motorOrderId,
                  orderNo: res.data.orderNo,
                  encryptKey: res.data.encryptKey,
                  terminalId: 'H5',
                  channelCode: 'HeNanMotorBike',
                  isH5: '1'
                }
              })
            }
            // 可回溯修改 end
          } else if (res.data.rtnCode === '9980' || res.data.rtnCode === '9998') {
            // 9981是下发修改  9980 是转人工
            if (localStorage.getItem('setMotorAreaName') === 'HE_BEI') {
              Dialog.alert({
                title: '温馨提示',
                message: '必传字段为空或字段未通过有效性校验，如有疑问请与门店联系',
                confirmButtonText: '确定',
                confirmButtonColor: '#592581'
              }).then(() => {
                // on close
              })
            } else {
              Dialog.alert({
                message: `<v-html>${res.data.rtnMsg}</v-html>`,
                confirmButtonText: '确定',
                confirmButtonColor: '#592581',
              }).then(() => {
                // on close
                this.$router.push('/motor/orderList')
              })
            }
          } else {
            if (localStorage.getItem('setMotorAreaName') === 'HE_BEI') {
              Dialog.alert({
                title: '温馨提示',
                message: '必传字段为空或字段未通过有效性校验，如有疑问请与门店联系',
                confirmButtonText: '确定',
                confirmButtonColor: '#592581'
              }).then(() => {
                // on close
              })
            } else {
              // this.$toast(res.data.rtnMsg)
              Dialog.alert({
                message: `<v-html>${res.data.rtnMsg}</v-html>`,
                confirmButtonText: '确定',
                confirmButtonColor: '#592581'
              }).then(() => {
                // on close
                // this.$router.push('/motor/orderList')
              })
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.switchs = false
        })
    },

    traceBack(data) {
      return new Promise(resolve => {
        if (
          !data ||
          !data.orderNo ||
          !data.resultObj ||
          !(data.resultObj.policyNo || data.resultObj.policyNoCI)
        ) {
          resolve()
        }
        try {
          const productInfo = checkFormat.interpretation(
            'H5',
            'DP_OWXPA'
          )
          const customers = this.getCustomers()
          const dataSet = {}
          this.$set(dataSet, 'request', {
            applyTime: new Date().getTime(),
            campaignId: productInfo.orderOrigin,
            campaignName: '紫金摩托车险',
            customer: customers,
            iseeBiz: '',
            orderNo: data.orderNo,
            // policyNo: data.resultObj.policyNoCI || '2059194101002200000F',
            policyNo: data.resultObj.policyNo || data.resultObj.policyNoCI,
            underwritingTime: new Date().getTime(),
            videoEndTime: new Date().getTime() + 1 * 60 * 1000
          })
          console.log(dataSet, 'dataSet')
          var a = window.getIseeBiz()
          console.log(a, '?????')
          a.then(
            r => {
              console.log(r, '可回溯码')
              dataSet.request.iseeBiz = r
              this.$http.post(api.traceBackNew, dataSet).finally(() => {
                resolve()
              })
            },
            err => {
              resolve()
            }
          ).catch(() => {
            resolve()
          })
        } catch (e) {
          resolve()
        }
      })
    },
    getCustomers() {
      // 投保人
      const applicantIn = this.$store.state.applicantIn
      // 被保人
      const recognizeeIn = this.$store.state.recognizeeIn
      const insuredList = []
      if (applicantIn) {
        insuredList.push({
          customIdNo: applicantIn.identifyNumber,
          customType: '1',
          customMobile: applicantIn.mobile,
          customName: applicantIn.insuredName,
          customIdType: this.getZhongAnIdentifyType(applicantIn.identifyType)
        })
      }
      if (recognizeeIn) {
        insuredList.push({
          customIdNo: recognizeeIn.identifyNumber,
          customType: '2',
          customMobile: recognizeeIn.mobile,
          customName: recognizeeIn.insuredName,
          customIdType: this.getZhongAnIdentifyType(recognizeeIn.identifyType)
        })
      }
      return insuredList
    },
    getZhongAnIdentifyType(zkingIdentifyType) {
      switch (zkingIdentifyType) {
        // 个人-------------------
        // 身份证
        case '01':
          return '111'
        // 户口薄
        case '02':
          return '113'
        // 中国护照
        case '03':
          return '414'
        // 军官证
        case '04':
          return '114'

        // 驾驶执照
        case '05':
          return '335'
        // 返乡证
        case '06':
          return '516'
        // 外国护照 ?待确认
        case '07':
          return '414'
          // 企业-------------------

        // 统一社会信用代码
        case '13':
          return '822'
        // 税务登记证
        case '12':
          return '824'
        // 工商营业执照
        case '11':
          return '821'
        // 组织机构代码证
        case '10':
          return '823'

        // 其它
        case '99':
          return '990'
        default:
          return '990'
      }
    },
    getContentTabs() { // 影像信息数据
      const params = {
        codeType: 'DocumentsType'
      }
      this.switchs = true
      this.$http
        .post(api.getByCodeType, params)
        .then((res) => {
          this.switchs = false
          if (res.status === 200) {
            const imgTypeDatas = res.data
            this.tabsContent = []
            for (const item in imgTypeDatas) {
              imgTypeDatas[item].fileType = imgTypeDatas[item].codeCode
              imgTypeDatas[item].text = imgTypeDatas[item].codecname
              imgTypeDatas[item].state = false
              imgTypeDatas[item].show = false
              imgTypeDatas[item].active = false
              imgTypeDatas[item].src = []
              this.tabsContent.push(imgTypeDatas[item])
            }
            // console.log(this.tabsContent, '影像排序数组===>')
            this.fileIdList = []
            const orderDetail = this.resultObj
            // console.log(orderDetail, '00000')
            this.fileIdList = []
            this.itemFileDataList = []
            if (Object.keys(orderDetail).length > 0) {
              if (orderDetail.itemFileDataList && orderDetail.itemFileDataList.length > 0 && orderDetail.itemFileDataList[0].fileList && orderDetail.itemFileDataList[0].fileList.length > 0) {
                this.itemFileDataList = orderDetail.itemFileDataList
              }
            } else {
              if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList && this.$store.state.itemFileDataList[0].fileList.length > 0) {
                this.itemFileDataList = this.$store.state.itemFileDataList
              }
            }
            if (orderDetail.submitInfo && Object.keys(orderDetail.submitInfo).length > 0 && orderDetail.submitInfo.remark !== '') {
              this.remark = orderDetail.submitInfo.remark
            }

            // 对已暂存的影像图片进行赋值
            if (this.itemFileDataList && this.itemFileDataList.length > 0) {
              let objs = {}
              this.itemFileDataList[0].fileList.forEach(value => {
                const fileStreams = value.fileId
                const obj = {
                  path: fileStreams
                }
                for (const item in this.tabsContent) {
                  if (Number(value.fileType) === Number(this.tabsContent[item].codeCode)) {
                    this.tabsContent[item].src.push(obj)
                    this.tabsContent[item].state = true
                    this.tabsContent[item].active = true
                  }
                }
                objs = {
                  fileId: value.fileId,
                  fileType: value.fileType
                }
                this.fileIdList.push(objs)
              })
            }
          } else {
            this.$toast('获取影像排序失败')
          }
        })
        .catch((err) => {
          console.log(err)
          this.switchs = false
        })
    },
    // 下发修改和暂存回显
    getMortorQuery() {
      this.switchs = true
      this.$http.post(api.queryOrderDetail + `?fileContentFlag=0&orderId=${this.$store.state.motorOrderDetail.orderId}`)
        .then(resTwo => {
          this.switchs = false
          if (resTwo.data.rtnCode === '0000') {
            this.resultObj = resTwo.data.resultObj
            // this.arrClause = resTwo.data.resultObj.engageList
            // this.$store.commit('setEngageList', resTwo.data.resultObj.engageList)
            // 获取影像资料排序
            this.getContentTabs()
          } else {
            this.$toast(resTwo.data.rtnMsg)
          }
        })
        .catch(err => {
          this.switchs = false
          console.log(err)
          this.$toast('订单详情获取失败')
        })
    },
    showMore(item, index) { // 选择影像信息
      if (item.active) {
        this.$set(item, 'active', false)
        item.state = false
        this.tabsContent[index].src = []
        const fileIdLists = []
        this.fileIdList.forEach((value) => {
          if (value.fileType !== item.fileType) {
            fileIdLists.push(value)
          }
        })
        this.fileIdList = fileIdLists
        this.temporary()
      } else {
        this.$set(item, 'active', true)
        item.state = true
      }
    },
    IMGRemove(item, key, index) { // 删除
      this.fileIdList.forEach((value, indexs) => {
        if (value.fileId === item.path) {
          this.fileIdList.splice(indexs, 1)
        }
      })
      this.temporary()
      this.tabsContent[key].src.splice(index, 1)
    },

    handleFile(event, key) { // input框
      const fileList = event.target.files
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size >= 20 * 1000 * 1000) {
          this.$toast('图片不能大于20M!')
        } else {
          if (!fileList[i]) return
          // 禁止的格式
          const forbidden = ['html', 'htm', 'svg'];
          const ext = fileList[i].name.toLowerCase().split('.').pop()
          if (forbidden.includes(ext)) {
            this.$toast('不支持上传 html/htm/svg 文件！')
            this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
            return
          }
          if (this.$refs.fileBtn) {
            this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
          }
          const reader = new FileReader()
          reader.readAsDataURL(fileList[i])
          const that = this
          reader.onload = function(e) {
            const param = {
              fileBase64: e.target.result.replace(/^.*?,/, ''),
              fileName: fileList[i].name,
              fileType: that.tabsContent[key].fileType
            }
            that.switchs = true
            that.$http
              .post(api.uploadFile, param)
              .then(res => {
                Toast.clear()
                if (res.data.rtnCode === '0000') {
                  const path = {
                    path: res.data.fileId
                  }
                  that.tabsContent[key].src.push(path)
                  const obj = {
                    fileName: fileList[i].name,
                    fileId: res.data.fileId,
                    fileType: that.tabsContent[key].fileType
                  }
                  that.fileIdList.push(obj)
                  that.temporary()
                } else {
                  that.$toast(res.data.rtnMsg)
                }
                that.switchs = false
              })
              .catch(error => {
                Toast.clear()
                console.log(error)
                that.switchs = false
              })
          }
        }
      }
    },
    goSpecial() { // 特别约定数据
      this.$router.push('motorClause')
    },
    delAgreed(items) { // 特约删除
      this.arrClause = this.arrClause.filter(clause => clause.clauseCode !== items.clauseCode)
      this.arrClause.forEach(item => {
        delete item.proType
      })
      this.temporary()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./supplementary.scss";
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/supplementary/index.vue